import React from 'react';
import { NavBar } from 'antd-mobile'

import { 
    BodyView
} from "../factory/ViewUtil";
import { ToDate2 } from '../factory/FactoryUtil';

const MessagePreviewController = ({goback, data}) => {
    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>Preview</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <div style={{display : 'flex', marginBottom : '10px'}}>
                    <div style={{flex : '1',  wordBreak : 'break-all'}}>{data.title}</div>
                    <div style={{marginLeft : '6px', fontSize : '14px', color : "#666",  wordBreak : 'break-all'}}>{ToDate2(data.creationDate)}</div>
                </div>
                <div style={{fontSize : '14px', color : 'gray',  wordBreak : 'break-all'}}>{data.message}</div>
                <div style={{margin : '20px 0', wordBreak : 'break-all', overflow : 'auto'}} dangerouslySetInnerHTML={{__html : data.body}}></div>
            </BodyView>
        </>
    );
}
export default React.memo(MessagePreviewController)